import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretLargeRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.2929 4.29289c.3605-.36048.9277-.38821 1.32-.08319l.0942.08319 11 11.00001c.3605.3605.3882.9277.0832 1.32l-.0832.0942-11 11c-.3905.3905-1.0237.3905-1.4142 0-.36049-.3605-.38822-.9277-.0832-1.32l.0832-.0942L20.585 16 10.2929 5.70711c-.36049-.36049-.38822-.92772-.0832-1.32001l.0832-.09421Z" })
});
export default SvgCaretLargeRight;
